module.exports = __webpack_public_path__ + "static/img/stage-mode-3.06c62164.png";